import styled from 'styled-components';
import { Layout, Typography, Button, Table } from 'antd';

import colors from '../../styles/colors';

const { Text } = Typography;
const { Content } = Layout;

export const Wrapper = styled(Content)`
  display: flex;
  flex-direction: column;
  padding: 14px 15px 0 13px;
`;

export const DivProgress = styled.div`
  position: relative;
  top: -82px;
`;

export const Title = styled(Text)`
  color: ${props => props.color || colors.greyText};
  font-size: ${props => props.size || 18}px;
  font-weight: ${props => (props.weight ? 'bold' : 'normal')};
  line-height: ${props => props.line || 21}px;
  > span {
    font-weight: bold;
  }
`;

export const ButtonIniciarAtendimento = styled(Button)`
  height: 50px;
  width: 170px;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  border: none;
  color: ${colors.branco} !important;
  background: ${props => props.background || '#24A95D'} !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
`;

export const ButtonCsv = styled(Button)`
  height: 45px;
  width: 150px;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  border: none;
  color: ${colors.branco} !important;
  background: ${props => props.background || '#24A95D'} !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
`;

export const CardTabs = styled.div`
  .ant-tabs {
    height: 100%;
    .ant-tabs-content {
      background: #fff;
      padding: 6px;
      height: 100%;
      border-radius: 4px;
      border: none;

      div::-webkit-scrollbar {
        width: 8px;
        border-radius: 20px;
        border: none;
      }

      div::-webkit-scrollbar-track {
        background: #f4f4f4;
        border-radius: 20px;
      }
      div::-webkit-scrollbar-thumb {
        background-color: #bdbdbd;
        border-radius: 20px;
      }
    }
  }
  .ant-tabs-nav-list {
    margin-left: 15px;
  }
  .ant-tabs-nav {
    margin: 0;
    .ant-tabs-tab {
      background: #fff;
      color: #707070;
      font-size: 14px;
      line-height: 22px;
    }
    .ant-tabs-tab-active {
      background: #24a95d;
      font-size: 14px;
      line-height: 22px;
      color: #707070;
      .ant-tabs-tab-btn {
        color: #707070;
      }
      .ant-tabs-tab-remove {
        color: #707070;
      }
    }
    th.ant-table-cell {
      height: 100%;
      background: #fff;
      border-bottom: 2px solid #cacaca;
      text-align: center;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0px;
`;

export const ContainerFilter = styled.div`
  width: 100%;
  margin: 0px 0;
  .ant-input-affix-wrapper,
  .ant-input-affix-wrapper-lg {
    background-color: ${colors.gbGrey};
    padding: 12px 9px;
    border: none;
    .ant-input-prefix {
      color: ${colors.verde};
      margin-left: 8px;
    }
    input {
      background-color: ${colors.gbGrey};
      font-size: 14px;
      font-weight: 20px;
      color: ${colors.greyText};
      margin-left: 8px;
    }
  }
`;

export const ContainerTable = styled.div`
  width: 100%;
`;

export const TableCustom = styled(Table)`
  .ant-table-thead ::before {
    display: none;
  }
  .ant-table-thead > tr > th {
    border-bottom: 2px solid #cacaca;
    background-color: ${colors.branco};
    color: ${colors.greyText};
  }
  .ant-table table {
    padding-right: 6px;
  }
  .ant-table-tbody > tr > td {
    border-bottom: none;
    font-size: 14px;
    color: #828282;
    padding: 6px;
  }
  .ant-table-cell-scrollbar {
    display: none;
  }
`;

export const ContainerConsultas = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
  overflow-y: hidden;
  height: 100%;
`;

export const ContentConsultas = styled(Content)`
  margin-bottom: 16px;
`;

export const BlocoCustonRealtorio = styled(Content)`
  border: none;
  background: #ffffff;
  padding: 10px 17px 10px 17px;
  border-radius: 4px;
`;
